import {
  Datatable,
  DatatableBody,
  DatatableCell,
  DatatableHead,
  DatatableHeader,
  DatatableRow,
} from '@monksflow/monks-ui';
import { format } from 'date-fns';
import { ExternalLinkIcon } from 'lucide-react';
import type { SelectProjectRow } from '../../lib/types';
import { useTranslation } from 'react-i18next';

interface SelectProjectTableProps {
  rows: SelectProjectRow[];
  onSelect: (platformProjectId: string) => void;
}

export function SelectProjectTable({ rows, onSelect }: SelectProjectTableProps) {
  const { t } = useTranslation('projects');

  return (
    <Datatable className="[&_thead_th]:border-b">
      <DatatableHeader>
        <DatatableRow>
          <DatatableHead scope="col">
            {t('adaptationProjectPicker.selectProjectTable.projectTitle')}
          </DatatableHead>
          <DatatableHead scope="col">
            {t('adaptationProjectPicker.selectProjectTable.owner')}
          </DatatableHead>
          <DatatableHead scope="col">
            {t('adaptationProjectPicker.selectProjectTable.createdAt')}
          </DatatableHead>
          <DatatableHead scope="col">
            <span className="sr-only">{t('adaptationProjectPicker.selectProjectTable.open')}</span>
          </DatatableHead>
        </DatatableRow>
      </DatatableHeader>
      <DatatableBody>
        {rows.map((row) => (
          <DatatableRow
            key={row.id}
            interactive
            className="h-16"
            onClick={() => onSelect(row.platformProjectId)}
          >
            <DatatableCell>
              <span className="truncate text-sm font-medium text-foreground">{row.title}</span>
            </DatatableCell>
            <DatatableCell>
              <span className="truncate text-sm text-foreground-alt">{row.ownerName}</span>
            </DatatableCell>
            <DatatableCell>
              <span className="text-sm text-foreground-alt">
                {/* eslint-disable-next-line i18next/no-literal-string -- date-fns format pattern, machine input to format() rather than translator-facing copy */}
                {format(new Date(row.createdAt), 'MMMM d, yyyy')}
              </span>
            </DatatableCell>
            <DatatableCell className="w-10 text-right">
              <ExternalLinkIcon className="size-4 text-muted-foreground" aria-hidden />
            </DatatableCell>
          </DatatableRow>
        ))}
      </DatatableBody>
    </Datatable>
  );
}
